import { BusinessCardField, BusinessCardLocationData } from '../../types';

interface CustomizeItemFormProps {
  data: BusinessCardLocationData;
  fields: BusinessCardField[];
  onFieldChange: (field: string, value: string) => void;
}

const META_FIELDS = ['is_saved_address', 'address_group', 'slight_bar'];
const PHONE_FIELDS = ['phone', 'cell_phone', 'fax', 'customer_service_phone', 'toll_free'];

export function CustomizeItemForm({ data, fields, onFieldChange }: CustomizeItemFormProps) {
  const renderableFields = fields.filter(f => !META_FIELDS.includes(f.key));

  return (
    <div className="space-y-3">
      {renderableFields.map(field => (
        <div key={field.key}>
          <label className="block text-sm font-medium text-gray-700 mb-1">{field.label}</label>
          <input
            type="text"
            value={data[field.key] || ''}
            onChange={e => onFieldChange(field.key, e.target.value)}
            placeholder={field.label}
            inputMode={PHONE_FIELDS.includes(field.key) ? 'tel' : undefined}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>
      ))}
    </div>
  );
}
